const SvgLogoArch = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1648_21117)">
      <path
        d="M32.0487 63.557C49.4499 63.557 63.5564 49.4505 63.5564 32.0493C63.5564 14.6481 49.4499 0.541595 32.0487 0.541595C14.6475 0.541595 0.541016 14.6481 0.541016 32.0493C0.541016 49.4505 14.6475 63.557 32.0487 63.557Z"
        fill="#3763FF"
      />
      <path
        d="M24.7442 24.3312L10.7627 10.3462V53.6085L21.5774 42.7938V31.9791C21.5774 28.994 22.7868 26.2886 24.7442 24.3312Z"
        fill="#363636"
      />
      <path
        d="M32.3921 21.1609C38.3658 21.1609 43.2069 26.002 43.2069 31.9756V42.7903L54.0216 53.605V10.3462H10.7627L24.7477 24.3312C26.7051 22.3738 29.4106 21.1644 32.3956 21.1644L32.3921 21.1609Z"
        fill="white"
      />
      <path
        d="M32.3911 31.9792L43.2058 42.7939V31.9792C43.2058 26.0055 38.3647 21.1644 32.3911 21.1644C29.406 21.1644 26.7006 22.3738 24.7432 24.3312L27.7457 27.3338L32.3911 31.9792Z"
        fill="#3763FF"
      />
      <path
        d="M24.744 24.3312C22.7866 26.2887 21.5771 28.9941 21.5771 31.9791V42.7939L32.3919 31.9791L24.744 24.3312Z"
        fill="white"
      />
      <path d="M43.2069 42.7938H21.5774L10.7627 53.6085H54.0251L43.2069 42.7938Z" fill="#363636" />
      <path d="M32.3919 31.9791L21.5771 42.7938H43.2066L32.3919 31.9791Z" fill="#D3DDFF" />
    </g>
    <defs>
      <clipPath id="clip0_1648_21117">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLogoArch;
